<script>
export default {
  name: 'MdTableRowGhost',
  props: {
    mdIndex: [String, Number],
    mdId: [String, Number],
    mdItem: [Array, Object],
  },
  render() {
    const defaultObject = this.$slots.default()[0];
    defaultObject.componentOptions.propsData.mdIndex = this.mdIndex;
    defaultObject.componentOptions.propsData.mdId = this.mdId;
    defaultObject.componentOptions.propsData.mdItem = this.mdItem;

    return defaultObject;
  },
};
</script>
